import { createRoot } from "react-dom/client";

import { App } from "./app";

if (import.meta.env.REACT_APP_API_MOCKING === "enabled" && import.meta.env.DEV) {
  const { worker } = await import("./__mocks__/browser");
  await worker.start();
}

createRoot(document.getElementById("root")!).render(<App />);
